import React, { useState } from "react";
import { signInWithEmailAndPassword, createUserWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";
import { ensureUser, updateProfile } from "../services/api";
import "./LoginPage.css";

function LoginPage() {
  const [isSignup, setIsSignup] = useState(false);
  const [form, setForm] = useState({ email: "", password: "", username: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  function handleChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");

    if (isSignup) {
      const u = form.username.trim();
      if (!u) { setError("Username is required"); return; }
      if (u.length < 2 || u.length > 30) { setError("Username must be 2–30 characters"); return; }
      if (!/^[a-zA-Z0-9_]+$/.test(u)) {
        setError("Username can only contain letters, numbers, and underscores");
        return;
      }
    }

    setLoading(true);
    try {
      if (isSignup) {
        await createUserWithEmailAndPassword(auth, form.email, form.password);
        await ensureUser();
        await updateProfile({ username: form.username.trim() });
      } else {
        await signInWithEmailAndPassword(auth, form.email, form.password);
        await ensureUser();
      }
      window.location.href = "/dashboard";
    } catch (err) {
      setError(err.message || "Authentication failed");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="lp-root">
      <div className="lp-orb lp-orb-a" />
      <div className="lp-orb lp-orb-b" />
      <div className="lp-grid" />

      {/* Left branding panel */}
      <div className="lp-left">
        <a href="/" className="lp-brand">
          <div className="lp-brand-icon">T</div>
          Tradernal
        </a>

        <div className="lp-left-body">
          <h1>Journal smarter.<br /><span>Trade better.</span></h1>
          <p>
            The premium trading journal for disciplined traders. Log trades,
            review screenshots, and unlock AI-powered insights.
          </p>

          <div className="lp-features">
            {[
              "AI daily & weekly review",
              "Screenshot-based analysis",
              "Group accountability circles",
              "Performance calendar & stats",
            ].map((f) => (
              <div className="lp-feature" key={f}>
                <div className="lp-dot" />
                <span>{f}</span>
              </div>
            ))}
          </div>

          <div className="lp-stats">
            <div className="lp-stat">
              <div className="lp-stat-val">4.9/5</div>
              <div className="lp-stat-lbl">Trader rating</div>
            </div>
            <div className="lp-stat-divider" />
            <div className="lp-stat">
              <div className="lp-stat-val">AI</div>
              <div className="lp-stat-lbl">Built-in review</div>
            </div>
            <div className="lp-stat-divider" />
            <div className="lp-stat">
              <div className="lp-stat-val">Free</div>
              <div className="lp-stat-lbl">To start</div>
            </div>
          </div>
        </div>
      </div>

      {/* Right form panel */}
      <div className="lp-right">
        <div className="lp-card">
          <a href="/" className="lp-mobile-brand">Tradernal</a>

          <div className="lp-card-head">
            <h2>{isSignup ? "Create your account" : "Welcome back"}</h2>
            <p>{isSignup ? "Start your trading journal for free." : "Sign in to your journal."}</p>
          </div>

          {error && <div className="lp-error">{error}</div>}

          <form onSubmit={handleSubmit} className="lp-form">
            {isSignup && (
              <div className="lp-field">
                <label>Username</label>
                <input
                  name="username"
                  value={form.username}
                  onChange={handleChange}
                  placeholder="e.g. tradermartin"
                  autoComplete="username"
                />
                <span className="lp-hint">Letters, numbers, underscores — shown in groups</span>
              </div>
            )}

            <div className="lp-field">
              <label>Email</label>
              <input
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                placeholder="you@email.com"
                autoComplete="email"
                required
              />
            </div>

            <div className="lp-field">
              <label>Password</label>
              <input
                type="password"
                name="password"
                value={form.password}
                onChange={handleChange}
                placeholder="••••••••"
                autoComplete={isSignup ? "new-password" : "current-password"}
                required
              />
            </div>

            <button className="lp-submit" type="submit" disabled={loading}>
              {loading ? "Please wait…" : isSignup ? "Create Account" : "Sign In"}
            </button>
          </form>

          <button
            className="lp-toggle"
            onClick={() => { setIsSignup(!isSignup); setError(""); }}
            type="button"
          >
            {isSignup
              ? "Already have an account? Sign in"
              : "Need an account? Create one"}
          </button>

          {!isSignup && (
            <p className="lp-note">Starter plan is free — no card required.</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default LoginPage;